// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container {
  color: black;
  font-size: 14px;
}

.modal-title {
  font-size: 18px;
  font-weight: bold;
}

.modal-title a {
  color: black;
  text-decoration: none;
}

.modal-title a:hover {
  opacity: 0.5;
}

.modal-subtitle {
  margin: 5px 0 20px;
}

.modal-subtitle span {
  font-weight: bold;
}

.modal-separator {
  background-color: #c9c7c7;
  height: 1px;
  margin: 30px 0;
  width: 100%;
}

.modal-footer {
  font-size: 16px;
  text-align: right;
  width: 100%;
}

.modal-footer span {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/ModalBox/ModalBox.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".modal-container {\n  color: black;\n  font-size: 14px;\n}\n\n.modal-title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.modal-title a {\n  color: black;\n  text-decoration: none;\n}\n\n.modal-title a:hover {\n  opacity: 0.5;\n}\n\n.modal-subtitle {\n  margin: 5px 0 20px;\n}\n\n.modal-subtitle span {\n  font-weight: bold;\n}\n\n.modal-separator {\n  background-color: #c9c7c7;\n  height: 1px;\n  margin: 30px 0;\n  width: 100%;\n}\n\n.modal-footer {\n  font-size: 16px;\n  text-align: right;\n  width: 100%;\n}\n\n.modal-footer span {\n  margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
